import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';

const link = document.createElement('link');
link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap';
link.rel = 'stylesheet';
document.head.appendChild(link);

document.body.style.fontFamily = 'Inter, sans-serif';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
